import React from "react";
import StripeForm from './StripeForm';
import OfflineForm from "./OfflineForm";

export default ({ paymentPath, setShow, spinnerMessage, buttonTitle, offline, successMessage }) => {
  if (offline) return (
    <OfflineForm
      paymentPath={paymentPath}
      setShow={() => setShow(false)}
      spinnerMessage={spinnerMessage}
      buttonTitle={buttonTitle}
      successMessage={successMessage}
    />
  );

  return (
    <StripeForm
      paymentPath={paymentPath}
      setShow={() => setShow(false)}
      spinnerMessage={spinnerMessage}
      buttonTitle={buttonTitle}
      successMessage={successMessage}
    />
  )
};

